import styled from 'styled-components';

export const CockpitFormGroupStyle = styled.div`
  background-color: #FFFFFF;

	.svg svg {
		min-height: 16px;
		min-width: 16px;
		max-width: 256px;
		max-height: 256px;
	}

	.cockpit-footer * {
		color: #8B8C99;
	}

	.App {
		background-color: #ECEDF2;
	}

	.cockpit-header__logo {
		margin-top: 1px;
	}
	
	.container {
		max-width: 100%;
		
		.row .col-12 > div {
			padding: 25px;
		}
		
		form .content-form .form-group .container-password span.fa {
			top: 6px !important;
		}
		
		.content-body {
			margin-bottom: 0;
			
			form input {
				font-size: 15px;
				color: #A2A2A2;
				border-radius: 0;
			}
		}
		
		.labelFormUser {
			color: #2B2932;	
			margin-bottom: 0;
		}
	}
`;
